import Vue from 'vue'
import 'normalize.css/normalize.css'// A modern alternative to CSS resets

import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// 倒入 http 文件夹下的 index.js
import api from './http/index'
import '@/styles/index.scss' // global css

import App from './App'
import router from './router'
import store from './store'

import i18n from './lang' // Internationalization
import './icons' // icon
import './errorLog'// error log
import './permission' // permission control
import './mock' // simulation data
import  './common/fonts/iconfont.css'
import  './styles/reset.scss'
import * as filters from './filters' // global filters
import Moment from 'moment'
import momentTimezone from 'moment-timezone'
import permission from './views/permission/permission'
import Cookies from 'js-cookie'
import './utils/flexible'

import onlyNumber from '@/directive/el-input'; //添加此行=>自定义全局指令
Vue.prototype.permission = permission
//兼容IE
import 'babel-polyfill'
import promise from 'es6-promise';
promise.polyfill();
Vue.prototype.momentTimezone = momentTimezone
/*console.log(momentTimezone.tz().format())*/
Vue.prototype.moment = Moment

// 前端页面监控
import {recordBehaviorsBefore,recordBehaviorsAfter} from './monitoring/performanceMonitoring'
Vue.prototype.recordBehaviorsBefore = recordBehaviorsBefore
Vue.prototype.recordBehaviorsAfter = recordBehaviorsAfter


Vue.use(Element, {
  size: 'medium', // set element-ui default size
  i18n: (key, value) =>{
    return i18n.t(key, value)
  }
})
if(Cookies.get('language') == "zh"){
  Vue.prototype.moment.locale('zh-cn')
}else if(Cookies.get('language') == "en"){
  Vue.prototype.moment.locale('en-gb')
}else if(Cookies.get('language') == "ko"){
  Vue.prototype.moment.locale('ko')
}else if(Cookies.get('language') == "zh_ft"){
  Vue.prototype.moment.locale('zh-mo')
}
Vue.use(onlyNumber); //添加此行=>使用该全局指令
Vue.use(api)
// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false
// 设置浏览器标题 6666
Vue.directive('title', {
  inserted: function (el, binding) {
    if(Cookies.get('language') == "zh"){
      document.title = 'Q-NEX管理后台'
    }else if(Cookies.get('language') == "en"){
      document.title = 'Q-NEX Dashboard'
    }else if(Cookies.get('language') == "ko"){
      document.title = 'Q-NEX Dashboard'
    }else if(Cookies.get('language') == "zh_ft"){
      document.title = 'Q-NEX 後臺管理'
    }else{
      document.title = 'Q-NEX Dashboard'
    }
  }
})


new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
})




// WEBPACK FOOTER //
// ./src/main.js